/**
 * Ленивая загрузка инструмента персонала «Отметить опасность» — тот же
 * паттерн, что FollowLazy/IsoLazy. Права персонала есть у единиц посетителей:
 * пока проверка прав (main.tsx → staff-api) не ответила «да», чанк с формой,
 * API и строками staff.* не грузится вовсе, стартовый бандл его не платит
 * (check:bundle).
 */
import type { ComponentType } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { importChunk } from '../lazy-retry'
import { staffAccess } from '../state'

let cached: ComponentType | null = null

export function StaffHazardLazy() {
  const allowed = staffAccess.value
  // Ленивый инициализатор обязателен (см. IsoLazy): иначе Preact вызвал бы
  // компонент как функцию-инициализатор состояния.
  const [View, setView] = useState<ComponentType | null>(() => cached)

  useEffect(() => {
    if (!allowed || View) return
    let alive = true
    void importChunk(() => import('./staff-hazard-sheet'))
      .then((m) => {
        cached = m.StaffHazardTool
        if (alive) setView(() => m.StaffHazardTool)
      })
      .catch(() => undefined)
    return () => {
      alive = false
    }
  }, [allowed, View])

  if (!allowed || !View) return null
  return <View />
}
